var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page", attrs: { id: "app" } }, [
    _c(
      "div",
      { staticClass: "pg-inner" },
      [
        _c(
          "app-header",
          {
            class: { admin: _vm.isAdminPart },
            on: {
              toggleMenu: function($event) {
                _vm.menuOpen = !_vm.menuOpen
              }
            }
          },
          [
            !_vm.isAdminPart
              ? _c(
                  "ul",
                  _vm._l(_vm.menuItems, function(menuItem, mi) {
                    return _c(
                      "li",
                      {
                        staticClass: "menu-item",
                        class: {
                          active: _vm.isActive(menuItem),
                          "mob-only": menuItem.loggedIn
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.resolvedLink(menuItem.link) },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.clickItem(menuItem)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(menuItem.title) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        menuItem.sub && menuItem.sub.length
                          ? _c(
                              "ul",
                              _vm._l(menuItem.sub, function(menuItem2, m2i) {
                                return _c("li", [
                                  _c(
                                    "a",
                                    {
                                      class: { active: menuItem2.active },
                                      attrs: {
                                        href: _vm.resolvedLink(menuItem2.link)
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.clickItem(menuItem2)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(menuItem2.title) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  menuItem2.sub && menuItem2.sub.length
                                    ? _c(
                                        "ul",
                                        _vm._l(menuItem2.sub, function(
                                          menuItem3,
                                          m3i
                                        ) {
                                          return _c("li", [
                                            _c(
                                              "a",
                                              {
                                                class: {
                                                  active: menuItem3.active
                                                },
                                                attrs: {
                                                  href: _vm.resolvedLink(
                                                    menuItem3.link
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.clickItem(
                                                      menuItem3
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(menuItem3.title) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ])
                                        }),
                                        0
                                      )
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAdminPart
              ? _c("ul", [
                  _c(
                    "li",
                    { class: { active: _vm.$route.name == "admin.videos" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "admin.videos" } } },
                        [_vm._v("Videos")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.$route.name == "admin.users" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "admin.users" } } },
                        [_vm._v("Users")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.$route.name == "admin.groups" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "admin.groups" } } },
                        [_vm._v("Pkgs")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.$route.name == "admin.types" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "admin.types" } } },
                        [_vm._v("Types")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      class: {
                        active:
                          [
                            "admin.specialities",
                            "admin.aparatus",
                            "admin.parts",
                            "admin.props",
                            "admin.levels"
                          ].indexOf(_vm.$route.name) != -1
                      }
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "admin.specialities" } } },
                        [_vm._v("Tags")]
                      ),
                      _vm._v(" "),
                      _c("ul", [
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.$route.name == "admin.specialities"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "admin.specialities" } } },
                              [_vm._v("Specialities")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: {
                              active: _vm.$route.name == "admin.aparatus"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "admin.aparatus" } } },
                              [_vm._v("Aparatus")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: { active: _vm.$route.name == "admin.parts" }
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "admin.parts" } } },
                              [_vm._v("Parts")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: { active: _vm.$route.name == "admin.props" }
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "admin.props" } } },
                              [_vm._v("Props")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: { active: _vm.$route.name == "admin.levels" }
                          },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "admin.levels" } } },
                              [_vm._v("Levels")]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.$route.name == "admin.stats" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "admin.stats" } } },
                        [_vm._v("Stats")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.$route.name == "admin.tests" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "admin.tests" } } },
                        [_vm._v("Tests")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "transition",
          { attrs: { name: "tr-section", mode: "out-in" } },
          [_c("router-view", { key: _vm.$route.fullPath })],
          1
        ),
        _vm._v(" "),
        _c("notifications"),
        _vm._v(" "),
        _vm.tcVisible ? _c("tc-view") : _vm._e(),
        _vm._v(" "),
        _c("app-footer", {
          attrs: { menuOpen: _vm.menuOpen },
          on: {
            "update:menuOpen": function($event) {
              _vm.menuOpen = $event
            },
            "update:menu-open": function($event) {
              _vm.menuOpen = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }